/* Café Agga — Beta v2 enhancements.
   Turns the retailer "Disponible en Magasin" logo band into a seamless,
   continuously-scrolling marquee (the native band is a Flickity carousel that
   steps every few seconds). We read its logos, build a duplicated CSS-animated
   track, and hide the original — no fighting Flickity's inline transforms. */
(function () {
  function buildMarquee() {
    var sec = document.querySelector('[data-section-id$="section_press_logos_iTGjrT"]');
    if (!sec || sec.querySelector('.agga-marquee')) return;
    var slides = sec.querySelectorAll('.logos__slide');
    if (!slides.length) return;

    var sources = [];
    slides.forEach(function (s) {
      var img = s.querySelector('img');
      if (img) sources.push({ src: img.currentSrc || img.src, alt: img.alt || '' });
    });
    if (!sources.length) return;

    var track = document.createElement('div');
    track.className = 'agga-marquee-track';
    // two copies → translateX(-50%) loops seamlessly
    for (var copy = 0; copy < 2; copy++) {
      sources.forEach(function (o) {
        var cell = document.createElement('div');
        cell.className = 'agga-marquee-item';
        var im = document.createElement('img');
        im.src = o.src;
        im.alt = copy === 0 ? o.alt : '';
        im.setAttribute('loading', 'lazy');
        if (copy === 1) im.setAttribute('aria-hidden', 'true');
        cell.appendChild(im);
        track.appendChild(cell);
      });
    }
    var wrap = document.createElement('div');
    wrap.className = 'agga-marquee';
    wrap.appendChild(track);

    var outer = sec.querySelector('.logos__slider__outer') || slides[0].closest('.logos__slider') || slides[0].parentElement;
    outer.parentNode.insertBefore(wrap, outer);
    outer.style.display = 'none';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(buildMarquee, 300); });
  } else {
    setTimeout(buildMarquee, 300);
  }
  window.addEventListener('load', buildMarquee);
})();

/* ---- Desktop nav: collapse the brand/support links into one "Explore" dropdown.
   Moves the non-shop top-level items (/pages/ + /blogs/) into a single dropdown.
   Draft-theme-scoped — the shared Shopify menu and the FR/EN translations are
   left untouched (we relocate the already-rendered, already-translated links). */
(function () {
  function build() {
    var tops = [].slice.call(document.querySelectorAll('.navlink--toplevel'))
      .filter(function (a) { return !a.closest('mobile-menu'); });
    var containers = [];
    tops.forEach(function (a) {
      var w = a.closest('.menu__item');
      var c = w ? w.parentElement : null;
      if (c && containers.indexOf(c) < 0) containers.push(c);
    });
    containers.forEach(processContainer);
  }
  function processContainer(container) {
    if (!container || container.querySelector('.agga-navgroup')) return;
    var targets = [].slice.call(container.children)
      .map(function (w) { return { wrap: w, a: w.querySelector ? w.querySelector('.navlink--toplevel') : null }; })
      .filter(function (o) {
        if (!o.a) return false;
        var h = o.a.getAttribute('href') || '';
        return (h.indexOf('/pages/') > -1 || h.indexOf('/blogs/') > -1) && !o.wrap.classList.contains('parent');
      });
    if (targets.length < 2) return;

    var lang = (document.documentElement.lang || '').toLowerCase();
    var label = lang.indexOf('fr') === 0 ? 'Explorer' : 'Explore';

    var group = document.createElement('div');
    group.className = 'menu__item agga-navgroup';
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'navlink navlink--toplevel agga-navgroup__trigger';
    trigger.setAttribute('aria-haspopup', 'true');
    trigger.innerHTML = '<span class="navtext">' + label + '</span><span class="agga-caret" aria-hidden="true"></span>';

    var panel = document.createElement('div');
    panel.className = 'agga-navgroup__panel';
    var ul = document.createElement('ul');
    targets.forEach(function (o) {
      var li = document.createElement('li');
      var link = document.createElement('a');
      link.href = o.a.getAttribute('href');
      link.className = 'agga-navsub';
      link.textContent = (o.a.textContent || '').trim();
      li.appendChild(link);
      ul.appendChild(li);
      if (o.wrap.parentNode) o.wrap.parentNode.removeChild(o.wrap);
    });
    panel.appendChild(ul);
    group.appendChild(trigger);
    group.appendChild(panel);
    container.appendChild(group);
  }
  function run() { try { build(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', function () { setTimeout(run, 600); });
})();

/* Hero background video is now rendered server-side in snippets/hero.liquid
   (no JS injection → no flash of the old hero on load). */
